import { LinkItem } from "@/components/institution/LinkButtonArray";

export const paymentLinks: (LinkItem & { url: string })[] = [
  {
    text: "Plată amendă",
    slug: "plata-amenda",
    url: "https://www.ghiseul.ro/ghiseul/public/amenzi",
  },
  {
    text: "Plăți taxe și impozite",
    slug: "plati-taxe-si-impozite",
    url: "https://www.ghiseul.ro/ghiseul/public/taxe",
  },
  {
    text: "Plăți amenzi COVID-19",
    slug: "plati-amenzi-covid-19",
    url: "https://www.ghiseul.ro/ghiseul/public/",
  },
  {
    text: "Plăți taxe pașaport",
    slug: "plati-taxe-pasaport",
    url: "https://www.ghiseul.ro/ghiseul/public/taxe/taxe-speciale/id/eyJpZEluc3QiOiA3MjEyLCAidGlwUGVycyI6MSwgInZhbGlkYXJpIjogInRydWUiLCAidGl0bHUiOiAiUGxhdMSDIGNvbnRyYXZhbG9hcmUgcGHImWFwb3J0In0%3D",
  },
  {
    text: "Plați diverse",
    slug: "plati-diverse",
    url: "https://www.ghiseul.ro/ghiseul/public/diverse",
  },
];
